import React, { useState } from 'react';
import { Button, Form, Alert, Spinner } from 'react-bootstrap';
import Modal from '../../../../Utilities/DraggableModal';
import { FaTrash } from 'react-icons/fa';
import useFetch from '../../../../Utilities/useFetch';
import FuncFetch from '../../../../Utilities/funcFetch';
import { useMsal } from '@azure/msal-react';

const PersonalLinks = ({ debtorID, readOnly }) => {
  const [showModal, setShowModal] = useState(false);
  const [newUrl, setNewUrl] = useState('');
  const [linkType, setLinkType] = useState('LinkedIn');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const { instance, accounts } = useMsal();

  // Available link types - easy to extend
  const linkTypes = [
    { value: 'LinkedIn', label: 'LinkedIn' }
    // Future types can be added here:
    // { value: 'Facebook', label: 'Facebook' },
    // { value: 'Twitter', label: 'Twitter' }
  ];

  const { data: personalLinks, loading, refetch } = useFetch(
    debtorID,
    `${process.env.REACT_APP_API_URL}/Claims/GetPersonalLinks`,
    'GET',
    null,
    { debtorID }
  );

  const handleAddLink = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    setSuccess('');

    // Basic LinkedIn URL validation
    if (linkType === 'LinkedIn' && !newUrl.includes('linkedin.com')) {
      setError('Please enter a valid LinkedIn URL');
      setSubmitting(false);
      return;
    }

    try {
      await FuncFetch(
        `${process.env.REACT_APP_API_URL}/Claims/PostPersonalLink`,
        {
          debtorID,
          url: newUrl,
          description: linkType
        },
        'POST',
        null,
        instance,
        accounts
      );

      setSuccess('Link added successfully!');
      setNewUrl('');
      setTimeout(() => {
        setShowModal(false);
        setSuccess('');
        refetch();
      }, 1500);
    } catch (err) {
      setError('Failed to add link. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const handleDeleteLink = async (linkId) => {
    if (!window.confirm('Are you sure you want to delete this link?')) return;

    try {
      const response = await FuncFetch(
        `${process.env.REACT_APP_API_URL}/Claims/DeletePersonalLink`,
        { id: linkId },
        'DELETE',
        null,
        instance,
        accounts
      );
      if (response) {
        refetch();
      }
    } catch (err) {
      console.error('Failed to delete link:', err);
      // Optionally show an error message to the user
      alert('Failed to delete link. Please try again.');
    }
  };

  if (loading) {
    return <Spinner animation="border" size="sm" />;
  }

  return (
    <>
      <Form.Label>Personal Links</Form.Label>
      <div className='personal-link-list'>
        {personalLinks && personalLinks.length > 0 ? (
          <>
            {personalLinks.map((link, index) => (
              <div key={index}>
                <a 
                  href={link.socialURL} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  title={link.socialURL}
                  
                >
                  {link.summary}
                </a>
                {!readOnly && (
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => handleDeleteLink(link.socialID)}
                    title="Delete link"
                  >
                    <FaTrash size={10} />
                  </Button>
                )}
              </div>
            ))}
          </>
        ) : (
          <p>No links added</p>
        )}
        
      </div>
        {!readOnly && (
          <Button
            variant="outline-primary"
            size="sm"
            onClick={() => setShowModal(true)}
          >
            Add Link
          </Button>
        )}

      {/* Add Link Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Personal Link</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleAddLink}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Link Type</Form.Label>
              <Form.Select
                value={linkType}
                onChange={(e) => setLinkType(e.target.value)}
                required
              >
                {linkTypes.map((type) => (
                  <option key={type.value} value={type.value}>
                    {type.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>URL</Form.Label>
              <Form.Control
                type="url"
                value={newUrl}
                onChange={(e) => setNewUrl(e.target.value)}
                placeholder={linkType === 'LinkedIn' ? 'https://www.linkedin.com/in/username' : 'Enter URL'}
                required
              />
              <Form.Text className="text-muted">
                {linkType === 'LinkedIn' && 'Please enter a valid LinkedIn profile URL'}
              </Form.Text>
            </Form.Group>

            {error && <Alert variant="danger">{error}</Alert>}
            {success && <Alert variant="success">{success}</Alert>}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" type="submit" disabled={submitting}>
              {submitting ? <Spinner animation="border" size="sm" /> : 'Add Link'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default PersonalLinks;